import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { TabsModule } from 'primeng/tabs';
import { of } from 'rxjs';
import { entite } from 'src/app/models/entite';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { PanelModule } from 'primeng/panel';
import { ListeVendeursEntiteComponent } from './liste-vendeurs-entite/liste-vendeurs-entite.component';
import { DialogModule } from 'primeng/dialog';
import { ListeProgrammesComponent } from 'src/app/tableaux-listes/liste-programmes/liste-programmes.component';
import { FormEntiteModifComponent } from '../form-entite-modif/form-entite-modif.component';
import { FormProgrammeComponent } from '../form-programme/form-programme.component';
import { FormVendeurComponent } from '../form-vendeur/form-vendeur.component';

@Component({
  selector: 'app-fiche-entite',
  templateUrl: './fiche-entite.component.html',
  imports: [CommonModule, ButtonModule,TabsModule,PanelModule,ListeVendeursEntiteComponent,DialogModule,ListeProgrammesComponent,FormEntiteModifComponent,FormProgrammeComponent,FormVendeurComponent],
  styleUrls: ['./fiche-entite.component.scss'],
  providers: [DialogService, MessageService]
})
export class FicheEntiteComponent {
  entiteForm!: FormGroup;
  monentite: entite = {
    numEntite: 0,
    numPere: new entite(),
    libelle: '',
    adresse1: '',
    adresse2: '',
    adresse3: '',
    codePostal: '',
    ville: '',
    type: '',
    ext: 0,
    tel: '',
    web: '',
    user: '',
    axe: '',
    dc: '',
    dm: '',
    formeJuridique: '',
    statut: 0,


  };
  constructor(public router: Router, public share: shareOpeSevices, public entiteservice: EntitebackService, private fb: FormBuilder) { }

  userForm = false;
  entite: any;

  showVendeur() {
    // this.messageService.add({ severity: 'success', detail: 'L’utilisateur Benoit ARVISET a bien été crée.' });
    this.userForm = true;
  }

  showProgramme() {
    this.share.sendFicheEntite(this.entite);
    this.share.programForm = true;

  }

  ngOnInit() {
    this.share.noeudficheEntite$.subscribe({
      next: ((data: any) => {
        this.getFicheEntite(data.data.id);
        this.entite = data;
        //this.share.sendFicheEntite(this.entite);
        //this.getFicheEntite(this.entite.data.id);
      }),
      complete: (() => {
      }),
      error: (err) => of({ dataStatut: "", errorMessage: err.error.message })
    });
  }

  getFicheEntite(numEntite: number) {
    this.entiteservice.getEntitebyId(numEntite).subscribe(
      (data: any) => {
        this.monentite = new entite();
        //this.monentite = data;

        if (

          data.formeJuridique === null || data.formeJuridique === '0' || data.formeJuridique === '00') {
          data.formeJuridique = '';

        }
        else {

          this.entiteservice.getFormjuridbyCode(data.formeJuridique).subscribe(dataj => {
            data.formeJuridique = dataj.libelle;

          })
        }

        this.monentite = data;

        if (

          this.monentite.type === null || this.monentite.type === '0' || this.monentite.type === '00') {
          this.monentite.type = '';

        } else {

          //this.entiteservice.getTypeSocietebyCode(this.monentite.type).subscribe(data => {
          this.monentite.type = data.type;

          //})
        }
      }
    )
  }
  showEntiteForm() {

    this.share.isForModif = true;
    this.share.sendFicheEntite(this.entite);

  }

  handleClose() {

    this.getFicheEntite(this.entite.data.id);
  }
  selectEntite(event: any) {

    this.share.sendFicheEntite(this.entite);

    this.router.navigate([`/fiche-entite`]);

  }
}
